/// <reference path="./custom.d.ts" />
// tslint:disable
/**
 * Integrations API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.0.1
 *
 *
 * NOTE: This file is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the file manually.
 */
import * as url from "url";
import * as portableFetch from "portable-fetch";
const BASE_PATH = "https://develop-api.resideadmissions.com/".replace(/\/+$/, "");
/**
 *
 * @export
 */
export const COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|",
};
/**
 *
 * @export
 * @class BaseAPI
 */
export class BaseAPI {
    constructor(configuration, basePath = BASE_PATH, fetch = portableFetch) {
        this.basePath = basePath;
        this.fetch = fetch;
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath || this.basePath;
        }
    }
}
;
/**
 *
 * @export
 * @class RequiredError
 * @extends {Error}
 */
export class RequiredError extends Error {
    constructor(field, msg) {
        super(msg);
        this.field = field;
    }
}
/**
 * IntegrationsServiceApi - fetch parameter creator
 * @export
 */
export const IntegrationsServiceApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Removes all QuickSight cache
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsServiceDeleteQuickSightCache(options = {}) {
            const localVarPath = `/api/integrations/quicksight/cache`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Retrieves all visible dashboards from quicksight
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsServiceGetAdminDashboards(options = {}) {
            const localVarPath = `/api/integrations/quicksight/admin/dashboards`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Returns an embedded url which renders a dashboard
         * @param {string} id the dashboard_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsServiceGetDashboardURL(id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling integrationsServiceGetDashboardURL.');
            }
            const localVarPath = `/api/integrations/quicksight/dashboards/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Retrives the dashboards the connected user can access to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsServiceGetDashboards(options = {}) {
            const localVarPath = `/api/integrations/quicksight/dashboards`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Retrieves the dashboards visible for one given user
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsServiceGetDashboardsUser(userId, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId', 'Required parameter userId was null or undefined when calling integrationsServiceGetDashboardsUser.');
            }
            const localVarPath = `/api/integrations/quicksight/admin/dashboards/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Checks service is up
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsServiceGetHealth(options = {}) {
            const localVarPath = `/api/integrations/health`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Grants and revokes permissions to a dashboard for a given user
         * @param {IntegrationsPostDashboardInput} body
         * @param {string} userId UserID is the the user identifier en reside
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsServicePostDashboard(body, userId, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling integrationsServicePostDashboard.');
            }
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId', 'Required parameter userId was null or undefined when calling integrationsServicePostDashboard.');
            }
            const localVarPath = `/api/integrations/quicksight/users/{userId}/dashboards`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("IntegrationsPostDashboardInput" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * IntegrationsServiceApi - functional programming interface
 * @export
 */
export const IntegrationsServiceApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Removes all QuickSight cache
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsServiceDeleteQuickSightCache(options) {
            const localVarFetchArgs = IntegrationsServiceApiFetchParamCreator(configuration).integrationsServiceDeleteQuickSightCache(options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json().then(data => ({ ...response, data }));
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Retrieves all visible dashboards from quicksight
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsServiceGetAdminDashboards(options) {
            const localVarFetchArgs = IntegrationsServiceApiFetchParamCreator(configuration).integrationsServiceGetAdminDashboards(options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json().then(data => ({ ...response, data }));
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Returns an embedded url which renders a dashboard
         * @param {string} id the dashboard_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsServiceGetDashboardURL(id, options) {
            const localVarFetchArgs = IntegrationsServiceApiFetchParamCreator(configuration).integrationsServiceGetDashboardURL(id, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json().then(data => ({ ...response, data }));
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Retrives the dashboards the connected user can access to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsServiceGetDashboards(options) {
            const localVarFetchArgs = IntegrationsServiceApiFetchParamCreator(configuration).integrationsServiceGetDashboards(options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json().then(data => ({ ...response, data }));
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Retrieves the dashboards visible for one given user
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsServiceGetDashboardsUser(userId, options) {
            const localVarFetchArgs = IntegrationsServiceApiFetchParamCreator(configuration).integrationsServiceGetDashboardsUser(userId, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json().then(data => ({ ...response, data }));
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Checks service is up
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsServiceGetHealth(options) {
            const localVarFetchArgs = IntegrationsServiceApiFetchParamCreator(configuration).integrationsServiceGetHealth(options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json().then(data => ({ ...response, data }));
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Grants and revokes permissions to a dashboard for a given user
         * @param {IntegrationsPostDashboardInput} body
         * @param {string} userId UserID is the the user identifier en reside
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsServicePostDashboard(body, userId, options) {
            const localVarFetchArgs = IntegrationsServiceApiFetchParamCreator(configuration).integrationsServicePostDashboard(body, userId, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json().then(data => ({ ...response, data }));
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
/**
 * IntegrationsServiceApi - factory interface
 * @export
 */
export const IntegrationsServiceApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @summary Removes all QuickSight cache
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsServiceDeleteQuickSightCache(options) {
            return IntegrationsServiceApiFp(configuration).integrationsServiceDeleteQuickSightCache(options)(fetch, basePath);
        },
        /**
         *
         * @summary Retrieves all visible dashboards from quicksight
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsServiceGetAdminDashboards(options) {
            return IntegrationsServiceApiFp(configuration).integrationsServiceGetAdminDashboards(options)(fetch, basePath);
        },
        /**
         *
         * @summary Returns an embedded url which renders a dashboard
         * @param {string} id the dashboard_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsServiceGetDashboardURL(id, options) {
            return IntegrationsServiceApiFp(configuration).integrationsServiceGetDashboardURL(id, options)(fetch, basePath);
        },
        /**
         *
         * @summary Retrives the dashboards the connected user can access to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsServiceGetDashboards(options) {
            return IntegrationsServiceApiFp(configuration).integrationsServiceGetDashboards(options)(fetch, basePath);
        },
        /**
         *
         * @summary Retrieves the dashboards visible for one given user
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsServiceGetDashboardsUser(userId, options) {
            return IntegrationsServiceApiFp(configuration).integrationsServiceGetDashboardsUser(userId, options)(fetch, basePath);
        },
        /**
         *
         * @summary Checks service is up
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsServiceGetHealth(options) {
            return IntegrationsServiceApiFp(configuration).integrationsServiceGetHealth(options)(fetch, basePath);
        },
        /**
         *
         * @summary Grants and revokes permissions to a dashboard for a given user
         * @param {IntegrationsPostDashboardInput} body
         * @param {string} userId UserID is the the user identifier en reside
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsServicePostDashboard(body, userId, options) {
            return IntegrationsServiceApiFp(configuration).integrationsServicePostDashboard(body, userId, options)(fetch, basePath);
        },
    };
};
/**
 * IntegrationsServiceApi - object-oriented interface
 * @export
 * @class IntegrationsServiceApi
 * @extends {BaseAPI}
 */
export class IntegrationsServiceApi extends BaseAPI {
    /**
     *
     * @summary Removes all QuickSight cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsServiceApi
     */
    integrationsServiceDeleteQuickSightCache(options) {
        return IntegrationsServiceApiFp(this.configuration).integrationsServiceDeleteQuickSightCache(options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Retrieves all visible dashboards from quicksight
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsServiceApi
     */
    integrationsServiceGetAdminDashboards(options) {
        return IntegrationsServiceApiFp(this.configuration).integrationsServiceGetAdminDashboards(options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Returns an embedded url which renders a dashboard
     * @param {string} id the dashboard_id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsServiceApi
     */
    integrationsServiceGetDashboardURL(id, options) {
        return IntegrationsServiceApiFp(this.configuration).integrationsServiceGetDashboardURL(id, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Retrives the dashboards the connected user can access to
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsServiceApi
     */
    integrationsServiceGetDashboards(options) {
        return IntegrationsServiceApiFp(this.configuration).integrationsServiceGetDashboards(options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Retrieves the dashboards visible for one given user
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsServiceApi
     */
    integrationsServiceGetDashboardsUser(userId, options) {
        return IntegrationsServiceApiFp(this.configuration).integrationsServiceGetDashboardsUser(userId, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Checks service is up
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsServiceApi
     */
    integrationsServiceGetHealth(options) {
        return IntegrationsServiceApiFp(this.configuration).integrationsServiceGetHealth(options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Grants and revokes permissions to a dashboard for a given user
     * @param {IntegrationsPostDashboardInput} body
     * @param {string} userId UserID is the the user identifier en reside
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsServiceApi
     */
    integrationsServicePostDashboard(body, userId, options) {
        return IntegrationsServiceApiFp(this.configuration).integrationsServicePostDashboard(body, userId, options)(this.fetch, this.basePath);
    }
}
